export function PermissionFormField(userPermissions, permission) {
  const couldShow =
    userPermissions.some(val => permission.includes(val)) ||
    permission.includes('all');
  // console.log(couldShow);
  return couldShow;
}
